import { type ReactElement, useEffect } from 'react';

import { Stack } from '@mui/material';

import { usePages, useUsersTotalPage } from '../hooks';

import { changeUsersPage, useUsersPagination } from '../store';
import { PagesButton } from '@/components';

export const PaginationPages = (): ReactElement => {
  const { page: currentPage } = useUsersPagination();
  const total = useUsersTotalPage();
  const { value, toggle } = usePages();

  useEffect(() => {
    if (currentPage <= total - 4) {
      if (currentPage > 4) toggle(currentPage);
      else toggle(1);
    } else toggle(total - 3);
  }, [currentPage]);

  const handleJump = (page: number): void => {
    changeUsersPage(page);
  };

  return (
    <Stack direction="row" sx={{ alignItems: 'center' }}>
      <PagesButton
        key={1}
        isActive={currentPage === 1}
        onClick={() => {
          handleJump(1);
        }}
      >
        1
      </PagesButton>
      {currentPage > 4 && total > 5 && total !== 6 ? (
        <PagesButton key={'ellipsis-start'}>...</PagesButton>
      ) : (
        total > 1 && (
          <PagesButton
            key={2}
            isActive={currentPage === 2}
            onClick={() => {
              handleJump(2);
            }}
          >
            2
          </PagesButton>
        )
      )}

      {total > 5
        ? total > 1 &&
          value.map((item, key) =>
            currentPage > 4 && currentPage < total - 2 ? (
              <PagesButton
                key={item}
                isActive={key === 1}
                onClick={() => {
                  handleJump(item);
                }}
              >
                {item}
              </PagesButton>
            ) : (
              <PagesButton
                key={item}
                isActive={currentPage === item}
                onClick={() => {
                  handleJump(item);
                }}
              >
                {item}
              </PagesButton>
            ),
          )
        : total === 5 && (
            <PagesButton
              key={3}
              isActive={currentPage === 3}
              onClick={() => {
                handleJump(3);
              }}
            >
              3
            </PagesButton>
          )}

      {total > 5 && currentPage < total - 3 ? (
        total === 6 ? (
          ''
        ) : (
          <PagesButton key={'ellipsis-end'}>...</PagesButton>
        )
      ) : total === 6 ? (
        ''
      ) : (
        total > 1 &&
        total !== 3 &&
        total !== 2 && (
          <PagesButton
            key={total - 1}
            isActive={currentPage === total - 1}
            onClick={() => {
              handleJump(total - 1);
            }}
          >
            {total - 1}
          </PagesButton>
        )
      )}

      {total > 1 && total !== 2 && (
        <PagesButton
          key={total}
          isActive={currentPage === total}
          onClick={() => {
            handleJump(total);
          }}
        >
          {total}
        </PagesButton>
      )}
    </Stack>
  );
};
